// HelpAssistant/useHelpFabDismissed.js
//
// Whether THIS user has dismissed the floating Help launcher, kept in sync
// between two components that are siblings rather than parent/child: the FAB
// (mounted at the app root in App.js) and the avatar/Profile menu (mounted in
// the header). A React context wrapping both would mean re-nesting App.js's
// provider stack around a UI preference; a subscribed external store is the
// smaller, more local change and is exactly what `useSyncExternalStore` is for
// (React 18.2 is already the app's React).
//
// The store is fabPersistence's localStorage + its window CustomEvent, so a
// write from either component re-renders the other, and a second tab stays in
// sync through the `storage` event.

import { useCallback, useSyncExternalStore } from "react";
import { isFabDismissed, subscribeHelpFab } from "./fabPersistence";

/**
 * @param {number|string|null} userId logged-in user id (null -> never dismissed)
 * @returns {boolean} true while the FAB is hidden for this user
 */
export default function useHelpFabDismissed(userId) {
  const getSnapshot = useCallback(() => isFabDismissed(userId), [userId]);
  // Server snapshot: nothing is dismissed during SSR/prerender.
  const getServerSnapshot = useCallback(() => false, []);
  return useSyncExternalStore(subscribeHelpFab, getSnapshot, getServerSnapshot);
}
